import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import {
  helpArticleListParams,
  helpArticleListQueryOptions,
  helpArticleListSearchSchema,
  HelpArticlesPage,
  helpCategoriesQueryOptions,
} from '@/features/help-center';

export const Route = createFileRoute('/_authed/_active/s/$storeId/help/')({
  // Typed as the raw input so links into the list (`<Link to=".../help">`) need no search.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    helpArticleListSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = Promise.all([
      context.queryClient
        .query({
          ...helpArticleListQueryOptions(params.storeId, helpArticleListParams(deps)),
          staleTime: 'static',
        })
        .catch(() => undefined),
      context.queryClient
        .query({ ...helpCategoriesQueryOptions(params.storeId), staleTime: 'static' })
        .catch(() => undefined),
    ]);
    // Filter, sort and page changes on the list must not wait for the fetch, or a second pick in
    // the filter would build on the stale URL. The page's own query shows the previous rows.
    if (cause !== 'stay') await prefetch;
  },
  component: HelpArticlesPage,
});
